import styles from "./draft-options.module.css";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { Toolbox } from "PosterEditor/sidebar/toolboxes/toolbox";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { usePaths } from "BEDROCK/paths";

interface DraftOptionsProps {
  onDismiss?: () => void;
}

export const DraftOptions = ({ onDismiss }: DraftOptionsProps) => {
  const { home, navigateTo } = usePaths();
  const { deleteProjectAsync } = useProjectStore();
  const { saveDraft, deleteDraft, project, existingEditedDraftID } =
    usePosterProject();

  const startNew = async () => {
    await deleteDraft();
    saveDraft();
    // Directly dismiss the dialog since projectsInStore may be stale after deletion
    onDismiss?.();
  };

  const continueProject = async () => {
    // Capture the draft ID BEFORE any deletions to avoid race conditions
    const draftID = existingEditedDraftID();
    if (draftID) {
      await deleteProjectAsync(project);
      // `navigateTo` does not work because we're already at `/editor` and it doesn't reload.
      window.location.href = `/project/${draftID}`;
    } else {
      navigateTo(home);
    }
  };

  return (
    <div className={styles.container}>
      <Toolbox collapsible={false} showTitleBar={false}>
        <div className={styles.content}>
          <h2>Discard existing project?</h2>
          <h3>
            If you customise this preset you'll <b>lose your changes</b>
          </h3>
        </div>
        <div className={styles.actions}>
          <CTAButton
            onClick={continueProject}
            variant="LINK"
            iconName="CHEVRON-LEFT"
            iconPosition="LEFT"
          >
            Existing project
          </CTAButton>
          <CTAButton
            onClick={startNew}
            variant="PRIMARY"
            iconName="CHEVRON-RIGHT"
            iconPosition="RIGHT"
          >
            Customise this preset
          </CTAButton>
        </div>
      </Toolbox>
    </div>
  );
};
